<template>
  <div v-if="show" class="notice_left" @click.stop="messageHandle">
    <div class="notice_title">
      <template v-if="userType==2">
        <w-dropdown @command="handleCommand">
          <span class="w__dropdown-link cursor-pointer" @mouseenter="selectLabel">
            {{messageLabel}}<i class="r2-icon-nav_arrow_drop_down w__icon--right"></i>
          </span>
          <w-dropdown-menu slot="dropdown">
            <w-dropdown-item :command="{label: '全部消息', value: 0}">
              <span :class="{'color-blue': messageTab === 0}">全部消息</span>
            </w-dropdown-item>
            <w-dropdown-item v-for="(item, i) in personTabsData" :key="i" :command="item">
              <span :class="{'color-blue': item.value === messageTab}">{{item.label}}</span>
            </w-dropdown-item>
          </w-dropdown-menu>
        </w-dropdown>
      </template>
      <template v-else>
        <w-dropdown @command="handleCommand">
          <span class="w__dropdown-link cursor-pointer" @mouseenter="selectLabel">
            {{messageLabel}}<i class="r2-icon-nav_arrow_drop_down w__icon--right"></i>
          </span>
          <w-dropdown-menu slot="dropdown">
            <w-dropdown-item :command="0">
              <span :class="{'color-blue': messageTab === 0}">全部消息</span>
            </w-dropdown-item>
            <template v-if="user.role === 1">
              <w-dropdown-item v-for="(item, i) in adminTabsData" :key="i" :command="item"><span :class="{'color-blue': item.value === messageTab}">{{item.label}}</span></w-dropdown-item>
            </template>
            <template v-else>
              <w-dropdown-item v-for="(item, i) in tabsData" :key="i" :command="item"><span :class="{'color-blue': item.value === messageTab}">{{item.label}}</span></w-dropdown-item>
            </template>
          </w-dropdown-menu>
        </w-dropdown>
      </template>
      <span class="float_right padding-0-10 font-12 color-999 cursor-pointer" @click="alreadReadMessage({})">全部标记为已读</span>
    </div>
    <div class="notice_box overflow-hidden" :class="{'pagination': total > pageSize}" v-loading="loading" element-loading-background="rgba(255,255,255,.6)">
      <template v-if="+state === 1">
        <w-scrollbar wrap-style="overflow-x: hidden;" style="height: 100%;">
          <ul class="notice_navs">
            <li class="notice_item" v-for="(i, k) in dataList" :key="k" @click="handleClick(i)">
              <div class="notice_item_img bg-green" :class="[{'read': i.state === 1 || i.readState === 2}]" v-if="i.messageType === 1">
                <i class="r2-icon-cmc_chat color-green"></i>
              </div>
              <div class="notice_item_img bg-orange" :class="[{'read': i.state === 1 || i.readState === 2}]" v-else-if="i.messageType === 2">
                <i class="r2-icon-av_featured_play_list color-orange" ></i>
              </div>
              <div class="notice_item_img bg-blue" :class="[{'read': i.state === 1 || i.readState === 2}]" v-else-if="i.messageType === undefined || i.messageType === 3">
                <i class="r2-icon-social_share color-blue"></i>
              </div>
              <div class="notice_item_img bg-purple" :class="[{'read': i.state === 1 || i.readState === 2}]" v-else-if="[4, 7].includes(i.messageType)">
                <i class="r2-icon-cmc_business color-purple"></i>
              </div>
              <div class="notice_item_img bg-purple" :class="[{'read': i.state === 1 || i.readState === 2}]" v-else-if="i.messageType === 5">
                <i class="r2-icon-social_group color-purple"></i>
              </div>
              <div class="notice_item_img bg-blue" :class="[{'read': i.state === 1 || i.readState === 2}]" v-else-if="i.messageType === 6">
                <i class="r2-icon-device_widgets color-blue"></i>
              </div>
              <div class="notice_item_info">
                <div :class="[i.state === 1 || i.readState === 2 ? 'color_color_b2':'', 'notice_info-text']">
                  <template v-if="i.messageType === undefined || i.messageType === 3">
                    <template v-if="!i.shareLink">
                      收到 {{i.authorAccount}} 分享的 {{i.fileName}} {{i.hasMarkup?"工程有批注":""}}
                    </template>
                    <template v-else>
                      我收到分享链接：{{i.shareLink}}
                    </template>
                  </template>
                  <template v-else-if="i.messageType === 1">
                    {{i.author + (i.tip ? ('，' + i.tip) : '') + (i.content ? ('，' + i.content) : '')}}
                  </template>
                  <template v-else-if="i.messageType === 2">
                    <template v-if="i.type === 13">
                      {{i.content || ''}}
                    </template>
                    <template v-else>
                      <template v-if="![9, 10].includes(i.type)">{{i.author || ''}}</template>
                      {{i.type === 9 ? (i.content || '') : (i.tip || '')}}
                    </template>
                  </template>
                  <template v-else-if="i.messageType === 7">
                    {{i.content}} <a v-if="i.extJson && i.extJson.extType === 0" @click.stop="handleAppeal(i)" href="javascript: void(0);" style="color: #2079FA;text-decoration: underline;">点此申诉</a>
                  </template>
                  <template v-else>
                    <!--{{i.author}}{{(i.tip || '') + (i.content ? '，' + i.content : '')}}-->
                    {{i.content}}
                  </template>
                </div>
                <div class="notice_info-msg" v-if="i.messageType === undefined || i.messageType === 3">
                  <span>
                    {{new Date(i.shareTime).toLocaleString().replace(',', '').split(' ')[0]}}
                  </span>
                  &nbsp;
                  <em style="max-width: 80px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;">
                    {{i | remainTimeFilter}}
                  </em>
                </div>
                <div class="notice_info-msg" v-else>
                  <span>{{new Date(i.createTime).toLocaleString()}}</span>
                  &nbsp;
                  <em style="max-width: 80px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;">
                    {{i.projectName}}
                  </em>
                </div>
              </div>
            </li>
          </ul>
        </w-scrollbar>
      </template>
      <div class="flex width-full height-full justify-center align-center color-999" v-else>
        <template v-if="+state === 0">消息正在加载...</template>
        <template v-if="+state === 2">您当前还没有收到消息哦~</template>
        <template v-if="+state === 3">加载消息失败！</template>
      </div>
    </div>
    <div class="notice_pagination text-align-right" v-if="total > pageSize">
      <w-pagination
        small
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :total="total">
      </w-pagination>
    </div>
    <div class="notice_footer" @click="showAllNotice">
      <div class="btn-wrapper">打开消息中心</div>
    </div>
  </div>
</template>

<script>
import MessageService from '@/assets/service/message'
import deleteUser from '@/assets/images/delete-user.png'
import addUser from '@/assets/images/add-user.png'
import file from '@/assets/images/file.png'
import files from '@/assets/images/files.png'
import folder from '@/assets/images/folder.png'
import {capitalize} from '@/assets/utils'
import queryString from 'querystring'
import {mapState} from 'vuex'
let timer
export default {
  name: 'LeftMessage',
  data () {
    return {
      state: 0, // 0 loading; 1 success; 2 nodata; 3 error;
      loading: false,
      dataList: [],
      pageNum: 1,
      pageSize: 50,
      pageSizes: [50, 100],
      total: 0,
      show: false,
      messageLabel: '全部消息',
      messageTab: 0, // 0 全部消息 1 表示批注消息； 2 表示项目消息； 3 表示分享消息
      tabsData: [
        {label: '分享消息', value: 3, name: 'fx'},
        {label: '批注消息', value: 1, name: 'pz'},
        {label: '项目消息', value: 2, name: 'xm'},
        {label: '企业消息', value: 4, name: 'qy'},
        {label: '系统消息', value: 7, name: 'sys'}
      ],
      adminTabsData: [
        {label: '角色待分配', value: 5, name: 'role'},
        // {label: '企业云产品管理', value: 6, name: 'application'}
        {label: '系统消息', value: 7, name: 'sys'}
      ],
      personTabsData: [
        {label: '分享消息', value: 3, name: 'fx'},
        {label: '系统消息', value: 7, name: 'sys'}
      ]
    }
  },
  props: {
    showLeftMessage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      userType: state => state.user.user.userType
    })
  },
  created () {
    this.show = this.showLeftMessage
  },
  watch: {
    messageTab () {
      clearInterval(timer)
      this.$nextTick(() => {
        this.state = 0
        this.pageNum = 1
        this.total = 0
        this.dataList = []
        this.queryMessageList()
      })
      timer = setInterval(this.queryMessageList, 60000)
    },
    showLeftMessage () {
      if (this.showLeftMessage) {
        this.messageTab = 0
        this.messageLabel = '全部消息'
        this.$nextTick(() => {
          this.queryMessageList()
        })
        timer = setInterval(this.queryMessageList, 60000)
      } else {
        clearInterval(timer)
        this.state = 0
        this.dataList = []
      }
      // console.log('------------')
      // console.log(this.showLeftMessage)
      this.show = this.showLeftMessage
    }
  },
  filters: {
    urlFilter (data) {
      let val = ''
      if (+data.type === 4) {
        val = addUser
      } else if (+data.type === 5) {
        val = deleteUser
      } else if (+data.type === 6) {
        val = file
      } else if (+data.type === 7) {
        val = files
      } else if (+data.type === 8) {
        val = folder
      } else {
        val = data.signedUrl
      }
      return val
    },
    remainTimeFilter (i) {
      let time = i.remainTime
      if (!i.shareLink && +i.state !== 2) {
        return ''
      }
      if (+i.state === 2) {
        return '已失效'
      }
      if (
        typeof time === 'object'
      ) {
        return '永久有效'
      } else if (
        typeof time !== 'object' && time <= 0
      ) {
        return '已失效'
      } else {
        let days = Math.floor(time / 86400000)
        let hours = Math.ceil((time % 86400000) / 3600000)
        let timeResult = days ? `${days}天${hours}小时` : `${hours}小时`
        return `剩余有效期：${timeResult}`
      }
    }
  },
  methods: {
    // 消息类别筛选事件
    selectLabel () {
      this.sentLog(100110003)
    },
    handleCommand ({label = '全部消息', value = 0}) {
      this.messageTab = value
      this.messageLabel = label
      switch (label) {
        case '全部消息':
          this.sentLog(100110004)
          break
        case '分享消息':
          this.sentLog(100110005)
          break
        case '项目消息':
          this.sentLog(100110006)
          break
        case '批注消息':
          this.sentLog(100110007)
          break
        case '企业消息':
          this.sentLog(100110008)
          break
        default:
          break
      }
    },
    // 标记分享消息已读
    alreadReadShareMessage (i) {
      i.readState = 2
      MessageService.getShareMessagesRead({shareRelationId: i.shareRelationId})
    },
    handleClick (i) {
      if (i.messageType === undefined || i.messageType === 3) {
        this.goShare(i)
      } else {
        this.goDecration(i)
      }
    },
    // 跳转到分享页面
    goShare (i) {
      // 标记该信息已读
      this.alreadReadShareMessage(i)
      // 失效消息不可点击
      if ((typeof i.remainTime !== 'object' && i.remainTime <= 0) || +i.state === 2) {
        return
      }
      // 打开外链
      let suffix = i.fileName.split('.').reverse()[0]
      let queryParams = queryString.stringify({
        shareToken: i.shareToken ? i.shareToken : 'null',
        fileId: i.fileId ? i.fileId : 'null',
        fileType: i.fileType ? i.fileType : 'null',
        jsonToken: i.jsonToken ? i.jsonToken : 'null',
        fileName: i.fileName ? i.fileName : 'null',
        shareId: i.shareId
      })
      let newUrl = `/#/share/${capitalize(suffix, true, true)}?${queryParams}`
      window.open(newUrl, '_blank')
    },
    // 展示消息弹框
    showAllNotice () {
      this.sentLog(100110010)
      this.$emit('showAllNotice')
      window.messageTab = this.messageTab.toString()
      this.messageTab = 0
      this.messageLabel = '全部消息'
    },
    // 阻止冒泡
    messageHandle () {

    },
    // 页码更改
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryMessageList()
    },
    // 更改页面大小
    handlePageSizeChange (index) {
      this.pageSize = index
      this.pageNum = 1
      this.queryMessageList()
    },
    // 请求消息列表
    queryMessageList () {
      let {pageNum = 1, pageSize = 50} = this
      let params = {
        pageNum,
        pageSize
      }
      let messageTab = this.messageTab
      this.loading = true
      let fn = 'getReceivedShareMessages'
      if (messageTab === 0) {
        fn = 'queryAllMessageList'
      } else if ([1, 2, 4, 5, 6, 7].includes(messageTab)) {
        fn = 'queryMessageList'
        params.type = messageTab
      }
      MessageService[fn](params).then((res) => {
        this.loading = false
        if (messageTab !== this.messageTab) {
          return
        }
        if (+res.code === 200) {
          if (res.data.totalCount) {
            this.state = 1
            this.total = res.data.totalCount
            let items = res.data.items || []
            items.forEach((item, index) => {
              if (item.extJson) {
                try {
                  item.extJson = JSON.parse(item.extJson)
                } catch (e) {
                  item.extJson = {}
                }
              }
            })
            this.dataList = items
            // this.dataList = res.data.items
          } else {
            this.state = 2
          }
        } else {
          this.total = 0
          this.pageNum = 1
          this.state = 3
        }
      }).catch((err) => {
        this.total = 0
        this.pageNum = 1
        this.loading = false
        this.state = 3
        console.log(err)
      })
    },
    // 标记消息已读
    alreadReadMessage (item = {}) {
      let type = item.messageType || 0
      let query = {}
      if (type) {
        query.type = type
      } else {
        query.type = ''
        this.sentLog(100110009)
      }
      let messageIds = item.messageId ? [item.messageId.toString()] : ''
      MessageService.putMessageState(messageIds, query).then((res) => {
        if (+res.code === 200) {
          // 如果是单条点击
          if (item.messageId) {
            item.state = 1
          } else {
            // 遍历列表，全部重置为已读
            this.dataList.forEach(item => {
              item.state = 1
            })
          }
          // this.$forceUpdate()
        } else {
          this.$message.error('修改状态失败')
        }
      }).catch((err) => {
        this.$message.error('修改状态失败')
        console.log('修改状态失败')
        console.log(err)
      })
    },
    // 点击消息、标记已读并跳转
    goDecration (item) {
      // 标记该信息已读
      this.alreadReadMessage(item)
      if (item.messageType === 5) {
        // 点击角色待分配
        this.$emit('closeMessage', '/manage/members')
      } else if (item.messageType === 6) {
        // 点击企业数据库管理
        this.$emit('closeMessage', '/manage/applications')
      } else if (+item.type === 4 || +item.type === 5 || +item.type === 6 || +item.type === 7 || +item.type === 8) {
        // 打开装饰外链
        window.open(window.location.origin + '/#/project/joined/list', 'zjy-deco')
      } else if (item.url) {
        let newUrl = item.url.replace(/:\/\/.*?deco-browsing/, `://${window.location.host}/deco-browsing`)
        window.open(newUrl, 'zjy-deco')
        if (window.name === 'zjy-deco') {
          this.closeMessage()
        }
      }
    },
    // 点击申诉
    handleAppeal (item) {
      this.$emit('closeMessage', 'ugc', item.extJson)
    }
  },
  beforeDestroy () {
    clearInterval(timer)
  }
}
</script>

<style lang="less">
  .notice_left {
    width: 400px;
    height: 580px;
    position: fixed;
    right: 20px;
    top: 56px;
    background: #fff;
    z-index: 2001;
    /*loading动画层级为2000*/
    overflow: hidden;
    border-image: linear-gradient(0deg, rgba(246, 246, 246, 1), rgba(238, 238, 238, 1), rgba(237, 237, 237, 1), rgba(231, 231, 231, 1)) 1 1;
    box-shadow: 0px 2px 16px 0px rgba(33,37,48,0.2);
    .notice_title {
      padding: 10px 10px 10px 20px;
      margin: 0;
      color: #2C3E50;
      font-size: 14px;
      height: 50px;
      line-height: 30px;
      border-bottom: 1px solid #ddd;
      box-sizing: border-box;
      .w__dropdown-link {
        -ms-user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        &:focus {
          outline: none;
        }
      }
      .red-point-mynotice {
        top: 11px;
        left: 64px;
        height: 6px;
        width: 6px;
        border-radius: 6px;
        display: inline-block;
        text-align: center;
        font-size: 0.1em;
        color: #fff;
        background: red;
        position: absolute;
        display: none;
      }
    }
    .notice_box {
      font-size: 14px;
      display: block;
      height: calc(100% - 100px);
      overflow: auto;
      &.pagination {
        height: calc(100% - 140px);
      }
      .notice_navs {
        padding: 0 24px 0 16px;
        margin: 0;
        .notice_item {
          padding: 8px 0;
          border-bottom: 1px solid rgba(33,37,48,0.1);;
          overflow: hidden;
          cursor: pointer;
          &:last-child {
            border-bottom: 0;
          }
          .notice_item_img {
            margin-top: 3px;
            float: left;
            width: 28px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            border-radius: 50%;
            &.bg-blue {
              background-color: rgba(32,121,250,0.1);
            }
            &.bg-green {
              background-color: rgba(0,196,97,0.1);
            }
            &.bg-orange {
              background-color: rgba(248,149,2,0.1);
            }
            &.bg-purple {
              background-color: rgba(158,70,204,0.1);
            }
            &.read {
              opacity: 0.6;
            }
            i {
              display: inline-block;
              font-size: 16px;
            }
            .item_auto_img {
              height: 38px !important;
              width: auto !important;
            }
            .item_img {
              background: #ddd;
            }
          }
          .notice_item_info {
            color: #333;
            overflow: unset;
            margin-left: 44px;
            .notice_info-msg {
              text-align: right;
              font-size: 12px;
              font-weight: 400;
              color: rgba(33,37,48,0.55);;
              line-height: 20px;
              height: 20px;
              span {
                float: left;
              }
            }
            .notice_info-text {
              font-size: 14px;
              font-weight: 400;
              color: #303133;
              line-height: 22px;
              text-overflow: ellipsis;
              display: -webkit-box;
              text-align: justify;
              word-break: break-all;
              .blue {
                color: #1A6DCD;
              }
            }
          }
        }
      }

    }
    .notice_pagination {
      height: 40px;
      padding: 7px 24px;
      box-sizing: border-box;
    }
    .notice_footer {
      cursor: pointer;
      color: #303133;
      text-align: center;
      padding: 0 16px;
      .btn-wrapper {
        border-top: 1px solid rgba(220, 223, 230, 1);
        height: 50px;
        line-height: 50px;
        box-sizing: border-box;
        &:hover {
          color: #2079fa;
        }
      }
    }
    .share_item {
      .notice_item_info {
        overflow: unset;
      }
    }
  }


  .notice_left .color_color_b2 .blue, .color_color_b2 .blue {
    color: #b2b2b2 !important;
  }


  .color_color_b2 {
    color: #b2b2b2 !important;
  }

  .message_fx {
    width: 56px;
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(44, 62, 80, 1);
    margin-right: 40px;
    margin-left: 8px;
  }

  .message_pz {
    width: 56px;
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(44, 62, 80, 1);
    margin-right: 40px;
    margin-left: 8px;
  }

  .message_xm {
    width: 56px;
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(44, 62, 80, 1);
  }

  .message_bar {
    position: absolute;
    bottom: -2px;
    left: 0;
    background: rgba(28, 108, 205, 1);
    width: 71px;
    height: 4px;
    transition: transform 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  .message_bar_fx {
    transform: translateX(10px);
  }

  .message_bar_pz {
    transform: translateX(118px);
  }

  .message_bar_xm {
    transform: translateX(220px);
  }

  .message_active {
    color: rgba(28, 108, 205, 1);
  }
</style>
